import { Redirect, Stack } from "expo-router";
import { ActivityIndicator } from "react-native";

import { CenteredScreen } from "~/components/ui";
import { useAuth } from "~/hooks/useAuth";
import { useWorkspaceSwitcher } from "~/hooks/workspace";
import { getPostAuthPath } from "~/utils/onboarding";

export default function AuthLayout() {
  const { session, user, loading, passwordRecoveryActive } = useAuth();
  const workspaces = useWorkspaceSwitcher();
  const hasSharedWorkspace = workspaces.workspaces.some(
    (workspace) => workspace.owner_id !== user?.id,
  );

  // Wait for the profile (and optional workspace directory) before deciding
  // where an already-authenticated visitor should go. Redirecting with a null
  // user sends people back to /login and races the in-flight sign-in handler.
  if (loading || (session?.user && (!user || workspaces.isLoading))) {
    return (
      <CenteredScreen>
        <ActivityIndicator />
      </CenteredScreen>
    );
  }

  if (session?.user) {
    if (passwordRecoveryActive) {
      return <Redirect href="/reset-password" />;
    }
    return (
      <Redirect href={getPostAuthPath(user, { hasSharedWorkspace }) as never} />
    );
  }

  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    />
  );
}
